import styled, { css } from 'styled-components'

export const OutOfOrderOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: ${props => props.theme.color.primaryDark};
  color: ${props => props.theme.color.inverted};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4vh 8vw;

  ${props =>
    props.theme.contrastMode &&
    css`
      background: #000000;
    `};
`

export const OutOfOrderContent = styled.div`
  width: min(38rem, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const OutOfOrderLogo = styled.div`
  margin-bottom: 3.5rem;

  svg {
    display: block;
    width: clamp(4.5rem, 15vw, 8.25rem);
    height: auto;
    fill: currentColor;
  }
`

export const OutOfOrderTitle = styled.h1`
  margin: 0;
  color: ${props => props.theme.color.inverted};
  font-size: 6rem;
  line-height: 1.05;
`

export const OutOfOrderMessage = styled.p`
  margin: 3rem 0 0;
  color: ${props => props.theme.color.primaryMedium};
  font-size: 1.5rem;
  opacity: 0.75;
  line-height: 1.3;
  max-width: 28rem;
`
